import { persist } from 'easy-peasy';
import tokenModel from './tokenModel';
import templateModel from './templateModel';
import unsplashModel from './unsplashModel';
import showMessageModel from './showMessageModel';
import sharedModel from './sharedModel';

const storeModel = {
	token: tokenModel,
	template: templateModel,
	unsplash: unsplashModel,
	showMessage: showMessageModel,
	shared: sharedModel
};

const model = persist(storeModel, {
	storage: 'localStorage',
	config: {
		blacklist: ['showMessage', 'unsplash', 'shared']
	}
});

export default model;
